import { useCallback } from 'react';
import type { GroupAnalysisType } from '@/generated/types/navigator/types.gen';
import { ExportModal } from '@/views/analysis/ExportModal/ExportModal';
import { useClientTerminology } from '@/views/list/NetworkTerms';

interface Props {
  showExportModal?: boolean;
  onClose?: () => void;
  selectedAnalysis: GroupAnalysisType;
}

export const AnalysisExport = ({
  showExportModal,
  onClose,
  selectedAnalysis,
}: Props) => {
  const intl = useClientTerminology();

  const getTrackingSuffix = useCallback(() => {
    return `${selectedAnalysis.toLocaleLowerCase()}_analysis`;
  }, [selectedAnalysis]);

  const title = intl.formatMessage(
    { id: 'action.export' },
    {
      thing: intl.formatMessage({ id: 'noun.spans' }),
    }
  );

  return (
    <ExportModal
      title={title}
      showExportModal={showExportModal}
      onClose={onClose}
      trackingSuffix={getTrackingSuffix()}
      exportEntityTranslationKey="noun.spans"
    />
  );
};
